const marketPrefix = "market";
export const prefixes = {
    button: `${marketPrefix}__button`,
    label: `${marketPrefix}__label`,
    labelName: `${marketPrefix}__label-name`,
    template: `${marketPrefix}__template`,
    header: `${marketPrefix}__header`,
    category: `${marketPrefix}s-category`,
    subcategory: `${marketPrefix}s-subcategory`,
    subcategories: `${marketPrefix}s-subcategories`,
    arrow: `${marketPrefix}__groups-arrow`,
    collapsible: `${marketPrefix}-collapsible`,
    expandable: `${marketPrefix}-button-expandable`,
    lazyRenderContainer: `${marketPrefix}__lazy-render-container`,
};
Object.freeze(prefixes);
export function getMarketComponentPrefix(component) {
    if (!prefixes[component]) {
        throw new Error(`${component} is not a valid market component name!`);
    }
    return prefixes[component];
}
//# sourceMappingURL=GetMarketComponentPrefix.js.map